export default __webpack_public_path__ + "static/media/578.d4c321f5.png";